<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="subheader-1 py-2"
          primary-title
          :style="'background-color: '+toolbar.back+';'"
        >
          <span :class="toolbar.class">Produto adicionado ao pedido</span>
        </v-card-title>

        <v-card-text>
          <v-btn
            :style="'background-color: '+toolbar.back+';'"
            flat dark block
            @click="dialog = false"
            class="mb-3"
          >
            Continue no cardápio
          </v-btn>
          <v-btn
            :style="'background-color: '+toolbar.back+';'"
            flat dark block
            @click.stop="verPedido"
          >
            Confira seu pedido
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props:[
    'toolbar'
  ],
  data() {
    return {
      dialog: false,
      product_id: 0
    };
  },
  methods:{
    verPedido(){
      this.dialog=false;
      this.$emit('abrir-dialog-pedido');
    },
    closeDialog(){
      this.dialog=false;
      console.log("fechou");
    },
    openDialog(){
      this.dialog=true;
      console.log("abriu");
      setTimeout(() => {
        this.closeDialog();
      }, "4000");
    }
  }
};
</script>